import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import {
  isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser, isAuthorizatedPage, checkApproved, checkOnboarding
} from '@/auth/utils'
import dashboard from './routes/dashboard'
import finance from './routes/finance'
import pages from './routes/pages'
import campaignManager from './routes/campaign-manager'
import scores from './routes/scores'
import users from './routes/users'
import smartReporting from './routes/smart-reporting'
import transparency from "@/router/routes/transparency";
import store from '@/store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'global-homePage' } },
    ...dashboard,
    ...scores,
    ...finance,
    ...campaignManager,
    ...pages,
    ...users,
    ...smartReporting,
    ...transparency,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}


router.beforeEach((to, from, next) => {
  // Eğer rota meta verisinde `showMessageBox` tanımlanmamışsa, varsayılan olarak true yap
  if (to.meta.showMessageBox === undefined) {
    to.meta.showMessageBox = true;
  }
  next();
});

router.beforeEach(async (to, from, next) => {
  try {

    const startTime = performance.now();
    const isLoggedIn = await isUserLoggedIn();
    const endTime = performance.now();
    console.log(`Call to isUserLoggedIn took ${endTime - startTime} milliseconds. Result: ${isLoggedIn}`);

    Vue.prototype.$http.post(
      'global/logs/page',
      {
        environment: Vue.prototype.$mainConfig.environment,
        toPageName: to.name,
        fromPageName: from.name,
      }
    )
    
    let isApproved = false;
    let onboardingStatus = {
      status: false,
      isCompleted: false,
      isWaitingForEtl: false
    };

    if (isLoggedIn) {
      try {
        // returns data if dispatch sent a fresh request otherwise returns undefined(stale data from store)
        const freshMetaData = await store.dispatch('adinSettings/fetchCustomerMetaData');
        const statusChecks = store.getters['adinSettings/getStatusChecks'];
        isApproved = statusChecks.consent;
        onboardingStatus = statusChecks.onboarding;
        // make sure consent is not approved if metadata is stale
        if(!freshMetaData && !isApproved){
          await store.dispatch('adinSettings/fetchCustomerMetaData', true)
          const statusChecks = store.getters['adinSettings/getStatusChecks'];
          isApproved = statusChecks.consent;
          onboardingStatus = statusChecks.onboarding;
        }
      } catch (error) {
        console.error(error);
      }
    }

    // Kullanıcı giriş yapmamışsa ve 'auth-login' sayfasında değilse yönlendir
    if (!isLoggedIn && to.name !== 'auth-login') {
      return next({ name: 'auth-login' });
    }
    if (!isLoggedIn && to.name === 'auth-login'){ 
      return next()
    }
    if (isLoggedIn && to.name === 'auth-login'){
      return next({ name: 'global-homePage' });
    }

    // Onboarding durumunu kontrol et
    if (isLoggedIn) {
      // Onboarding tamamlanmışsa
      if (onboardingStatus.isCompleted) {
        // Onay yoksa, onay sayfasına yönlendir
        if (!isApproved && to.name !== 'global-consent') {
          return next({ name: 'global-consent' });
        }
        // Onay sayfasındayken onay varsa ana sayfaya yönlendir
        if (to.name === 'global-consent' && isApproved) {
          return next({ name: 'homePage' });
        }
      } 
      // ETL işlemi bekleniyor durumundaysa
      else if (onboardingStatus.isWaitingForEtl) {
        // Eğer bekleme sayfasında değilse, bekleme sayfasına yönlendir
        if (to.name !== 'global-onboardingWaiting') {
          return next({name : 'global-onboardingWaiting'});
        }
      } 
      // Onboarding tamamlanmamış ve ETL beklemiyor durumdaysa
      else {
        // Onboarding sayfasında değilse, onboarding sayfasına yönlendir
        if (to.name !== 'global-onboardingForm') {
          return next({ name: 'global-onboardingForm' });
        }
      }
    }

    // Kullanıcı giriş yapmışsa ve rota 'redirectIfLoggedIn' içeriyorsa
    if (to.meta.redirectIfLoggedIn && isLoggedIn) {
      const userData = getUserData();
      return next(getHomeRouteForLoggedInUser(userData ? userData.role : null));
    }

    // Sayfaya erişim yetkisi yoksa 'misc-not-authorized' sayfasına yönlendir
    // if (isLoggedIn) {
    //   const pageAuthorization = await isAuthorizatedPage(to.name);
    //   if (!pageAuthorization && to.name !== 'misc-not-authorized') {
    //     return next({ name: 'misc-not-authorized' });
    //   }
    // }

    console.log(`PATH: ${to.path}, NAME: ${to.name}`);
    next(); // Yönlendirme başarılıysa devam et
  } catch (error) {
    console.error(error);
    next({ name: 'error-404' });
  }


  // ready to request
  //Vue.prototype.$filter.store.set.isReady(false)
  //Vue.prototype.$filter.store.set.isReadyMetrics(false)
  // if (!Vue.prototype.$filter.data.filterData.brand) {
  //   Vue.prototype.$filter.state.set.isReady(false)
  // startTime = performance.now()
  // const isReadyFilter = await Vue.prototype.$filter.methods.getFilterData()
  // endTime = performance.now()
  // console.log(`Call to isReadyFilter took ${endTime - startTime} milliseconds Result: ${isReadyFilter}`)
  // startTime = performance.now()
  // const returnOfInitializer = await Vue.prototype.$filter.methods.initializeFilterComponent()
  // endTime = performance.now()
  // console.log(`Call to returnOfInitializer took ${endTime - startTime} milliseconds Result: ${returnOfInitializer}`)
  // console.log(returnOfInitializer)
  // returnOfInitializer.forEach(r => console.log(r))
  // }
  // return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
